// MoveOn hip "switch" listicle: FAQ accordion, phone compare carousel, sticky bar.
(function () {
  // Accordions (FAQ + offer details; instant, per DS V2)
  document.querySelectorAll('.mo-acc-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.nextElementSibling.classList.toggle('is-open');
      btn.querySelector('.mo-acc-sym').textContent = open ? '−' : '+';
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  // Offer gallery: cross-fade + thumbnails (same behaviour as the live listicle)
  var slides = [].slice.call(document.querySelectorAll('[data-gal-slide]'));
  var thumbs = [].slice.call(document.querySelectorAll('[data-gal-thumb]'));
  function showSlide(n) {
    slides.forEach(function (img, i) { img.classList.toggle('is-active', i === n); });
    thumbs.forEach(function (b, i) { b.classList.toggle('is-active', i === n); b.setAttribute('aria-current', i === n ? 'true' : 'false'); });
  }
  thumbs.forEach(function (b, i) { b.addEventListener('click', function () { showSlide(i); }); });
  if (slides.length) showSlide(0);

  // Review wall: each column scrolls its doubled cards at data-speed px/s (live listicle behaviour)
  document.querySelectorAll('.mo-vtrack[data-speed]').forEach(function (t) {
    function start() { var half = t.scrollHeight / 2; if (!half) return; t.style.setProperty('--lh-dur', (half / Number(t.dataset.speed)) + 's'); t.classList.add('is-moving'); }
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
  });
  // Expert clips stay muted and looping
  document.querySelectorAll('video[data-pro]').forEach(function (v) { v.muted = true; v.loop = true; v.addEventListener('volumechange', function () { v.muted = true; }); });

  // Below-the-fold clips: attach the src ~2 screens before they scroll in, so they are already
  // moving when seen; pause while off screen. They are the explainers, so they always play
  // (no reduced-motion / data-saver skip: Brandon 2026-10-18).
  var sachetVids = [].slice.call(document.querySelectorAll('video[data-muted-video]'));
  function attach(v) { var src = v.getAttribute('data-src'); if (src) { v.removeAttribute('data-src'); v.src = src; v.load(); } }
  function tryPlay(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { var v = e.target; v.muted = true; v._lhVis = e.isIntersecting; if (e.isIntersecting) { attach(v); tryPlay(v); } else if (!v.paused) v.pause(); });
    }, { rootMargin: '1500px 0px' });
    sachetVids.forEach(function (v) {
      io.observe(v);
      // iPhone can refuse the first play() (Low Power Mode, or no frames yet): retry once frames arrive
      v.addEventListener('canplay', function () { if (v._lhVis && v.paused) tryPlay(v); });
    });
    // ...and on every tap / scroll-release, which iOS always counts as permission to play
    var kick = function () { sachetVids.forEach(function (v) { if (v._lhVis && v.paused) { attach(v); tryPlay(v); } }); };
    ['touchend', 'click', 'keydown'].forEach(function (t) { document.addEventListener(t, kick, { passive: true }); });
  } else sachetVids.forEach(function (v) { attach(v); tryPlay(v); });

  // Hero loop: the most important media, so it is NOT lazy. src + autoplay + preload are in the
  // markup, the hero still is its poster (no blank frame). This only re-tries play() for phones
  // that refuse autoplay (iPhone Low Power Mode): on load, and on the visitor's first touch.
  var heroVid = document.querySelector('video[data-hero-video]');
  if (heroVid) {
    heroVid.muted = true;
    var heroPlay = function () { if (heroVid.paused) tryPlay(heroVid); };
    heroPlay();
    heroVid.addEventListener('canplay', heroPlay);
    ['touchstart', 'touchend', 'click', 'scroll'].forEach(function (t) { window.addEventListener(t, heroPlay, { passive: true, once: true }); });
  }

  // Sticky bar mirrors the buy box selection (mo-offer.js fires mo-offer:change)
  document.addEventListener('mo-offer:change', function (e) {
    var d = e.detail, t = document.querySelector('.mo-stickytitle'), m = document.querySelector('.mo-stickymeta');
    if (t) t.textContent = 'MoveOn · ' + d.label;
    // Lead with the monthly price, rounded up like the buy box cards (Brandon 2026-10-17)
    var days = parseInt(d.every, 10) || 30, months = Math.round(days / 30);
    var price = days >= 30 ? '<b>$' + Math.ceil(d.price * 30 / days - 1e-9) + '/mo</b>' + (months > 1 ? ' for ' + months + ' months' : '')
                           : '<b>$' + d.price + '</b> for ' + days + ' days';
    if (m) m.innerHTML = price + '<span class="lh-sk-tail"> · ' + (d.sub ? 'cancel anytime' : 'one-time') + '</span>';
  });

  // Compare table: on phones show the label column, MoveOn, and one rival at a time
  var wrap = document.getElementById('compare');
  var nav = document.getElementById('cmpnav');
  var dotsEl = document.getElementById('cmpdots');
  if (wrap && nav) {
    var rows = Array.prototype.slice.call(wrap.querySelectorAll('tr'));
    var rivals = wrap.querySelectorAll('thead th.is-rival').length;   // columns 2..(1+rivals)
    var idx = 0, dots = [];
    for (var i = 0; i < rivals; i++) {
      var d = document.createElement('button');
      d.setAttribute('aria-label', 'Show supplement ' + (i + 1));
      (function (n) { d.addEventListener('click', function () { idx = n; paint(); }); })(i);
      dotsEl.appendChild(d); dots.push(d);
    }
    var mq = window.matchMedia('(max-width: 700px)');
    function paint() {
      var on = mq.matches;
      wrap.classList.toggle('is-carousel', on);
      nav.hidden = !on;
      rows.forEach(function (tr) {
        Array.prototype.forEach.call(tr.children, function (cell, c) {
          cell.style.display = (!on || c < 2 || c === 2 + idx) ? '' : 'none';
        });
      });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
    }
    nav.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () { idx = (idx + Number(b.dataset.step) + rivals) % rivals; paint(); });
    });
    mq.addEventListener('change', paint);
    paint();
  }

  // Sticky bar: up after the hero, down while the offer is on screen
  var sticky = document.getElementById('sticky');
  var hero = document.querySelector('.lh-hero');
  var offer = document.getElementById('offer');
  if (sticky && hero && offer) {
    var pastHero = false, offerVisible = false;
    function update() { sticky.classList.toggle('is-up', pastHero && !offerVisible); }
    new IntersectionObserver(function (e) { pastHero = !e[0].isIntersecting; update(); }).observe(hero);
    new IntersectionObserver(function (e) { offerVisible = e[0].isIntersecting; update(); }, { threshold: 0.15 }).observe(offer);
  }
})();
